import React, { Component } from 'react';
import {Field, reduxForm} from "redux-form";
import {renderField} from "../Components/form";
import {connect} from "react-redux";
import {Spinner} from "./Spinner";

const mapStateToProps = (state) => ({
    ...state
});
const mapDispatchToProps = {

};

class SignatureForm extends Component {

  render() {
    const {stateValue, setStateFromProps} = this.props;

    if(!this.props.initialValues){
      return (<Spinner/>);
    }

    return (
      <div>
        <form>
          <Field name="name" label="Imię i nazwisko:" type="text" component={renderField} onChange={setStateFromProps} value={stateValue.name}/>
          <Field name="jobTitle" label="Stanowisko:" type="text" component={renderField} onChange={setStateFromProps} value={stateValue.jobTitle}/>
          <Field name="cellphone" label="Telefon 1:" type="text" component={renderField} onChange={setStateFromProps} value={stateValue.cellphone}/>
          <Field name="phone" label="Telefon 2:" type="text" component={renderField} onChange={setStateFromProps} value={stateValue.phone}/>
          <Field name="mail" label="Email:" type="text" component={renderField} onChange={setStateFromProps} value={stateValue.mail}/>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'signatureForm',
  enableReinitialize: true
})(connect(mapStateToProps, mapDispatchToProps)(SignatureForm));



// WEBPACK FOOTER //
// src/Components/SignatureForm.js